import fallbackImg from '../../assets/images/img/sikinitem-fallback.svg';
import { URLS } from 'services/constant-urls';

export const skinItemImage = (src?: string, width?: number | string, height?: number | string) => {
  const ABS_URL_OR_ROOT = /^(?:https?:)?\/\/|^\//;
  const safeSrc = (src && src.trim()) || fallbackImg;

  const needsPrefix =
    !ABS_URL_OR_ROOT.test(safeSrc) && !safeSrc.startsWith(URLS.urlInventoryExchange);
  const base = needsPrefix ? URLS.urlInventoryExchange : '';

  const shouldAppendSize =
    !!width && !!height && safeSrc !== fallbackImg && !ABS_URL_OR_ROOT.test(safeSrc);
  const size = shouldAppendSize ? `/${width}x${height}` : '';

  return `${base}${safeSrc}${size}`;
};
